module.exports = __webpack_public_path__ + "images/plp/plp-van-logo.svg";